/**
 * Box type filtering rules for shipment containers.
 *
 * Pallet containers accept only box types whose keys start with PALLET_BOX_TYPE_PREFIX.
 * All other container kinds (cartons, case packs, ...) accept everything *except*
 * that prefix.
 */
export var PALLET_BOX_TYPE_PREFIX = 'BtPallet';
export var PALLET_CONTAINER_TYPE_ID = 'CtPallet';
export var isPalletContainerType = function (containerTypeEnumId) {
    return containerTypeEnumId === PALLET_CONTAINER_TYPE_ID;
};
export var boxKindForContainerType = function (containerTypeEnumId) {
    return isPalletContainerType(containerTypeEnumId) ? 'pallet' : 'carton';
};
export var filterBoxTypesForContainer = function (boxTypes, kind) {
    return kind === 'pallet'
        ? boxTypes.filter(function (b) { return b.key.startsWith(PALLET_BOX_TYPE_PREFIX); })
        : boxTypes.filter(function (b) { return !b.key.startsWith(PALLET_BOX_TYPE_PREFIX); });
};
